import Add from "../../table/Add";
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { addChack, chackTitle } from "../../../constants";
import { Button, Alert } from "reactstrap";

const AddChack = () => {
  const navigate = useNavigate();
  const [schemeVillageData, setSchemeVillageData] = useState<any>([]);
  const [distributaryData, setDistributaryData] = useState<any>([]);
  const [wuaData, setWuaData] = useState<any>([]);
  const handleSubmit = async (data: any) => {
    try {
      const response = await ApiService.axiosApi(`/chack`, {
        method: "POST",
        data: data,
      });
      if (response.success) {
        toast.success(response.message || "Chack Detail Added successfully");
        navigate(-1);
      } else {
        toast.error(response.message || "Failed to add Chack Detail");
      }
    } catch (error: any) {
      toast.error(error.message || "Failed to add Chack Detail");
    }
  };

  useEffect(() => {
    const fetchSchemeVillage = async () => {
      try {
        const response = await ApiService.axiosApi(`/schemevillage`, {
          method: "GET",
          params: {
            pageNumber: 0,
            pageSize: 0,
          },
        });
        if (response.success) {
          setSchemeVillageData(response.data.data);
        }
      } catch (error: any) {
        toast.error(error.message || "Failed to fetch Scheme Village");
      }
    };

    const fecthWua = async () => {
      try {
        const response = await ApiService.axiosApi(`/wua`, {
          method: "GET",
          params: {
            pageNumber: 0,
            pageSize: 0,
          },
        });
        if (response.success) {
          setWuaData(response.data.data);
        }
      } catch (error: any) {
        toast.error(error.message || "Failed to fetch Scheme Village");
      }
    };
    fetchSchemeVillage();
    fecthWua();
  }, []);
  useEffect(() => {
    const fetchDistributaryData = async () => {
      try {
        const response = await ApiService.axiosApi(`/dzone`, {
          method: "GET",
          params: {
            pageNumber: 0,
            pageSize: 0,
          },
        });
        if (response.success) {
          setDistributaryData(response.data.data);
        }
      } catch (error: any) {
        toast.error(error.message || "Failed to fetch Distributary Zone");
      }
    };
    fetchDistributaryData();
  }, []);

  return (
    <>
 
      
          
   

      <Add
        isAlert={true}
        title={addChack}
        parentTitle={chackTitle}
        onSubmit={handleSubmit}
        fields={[
          {
            name: "ChackName",
            label: "Chak Name",
            type: "text",
            validation: { required: "Chack Name is required" },
          },
          {
            name: "ChackArea",
            label: "Chak Area",
            type: "text",
            validation: { required: "Chack Area is required" },
          },
          {
            name: "Duty",
            label: "Duty",
            type: "text",
            validation: { required: "Duty is required" },
          },
          {
            name: "PCFRV_ScadaControl",
            label: "PCFRV Scada Control",
            type: "text",
            validation: { required: "PCFR V Scada Control is required" },
          },
          {
            name: "No_Of_ON_OF_Valves",
            label: "No Of ON OF Valves",
            type: "text",
            validation: { required: "No Of ON OF Valves is required" },
          },

          {
            name: "ChackLeader",
            label: "Chak Leader",
            type: "text",
            validation: { required: "Chack Leader is required" },
          },
          {
            name: "ChackLeader_MobileNumber",
            label: "Chak Leader Mobile Number",
            type: "text",
            validation: { required: "Chack Leader Mobile Number is required" },
          },
          {
            name: "Long",
            label: "Long",
            type: "text",
            validation: { required: "Long is required" },
          },
          {
            name: "Lat",
            label: "Lat",
            type: "text",
            validation: { required: "Lat is required" },
          },
          {
            name: "Duid",
            label: "Duid",
            type: "text",
            validation: { required: "Duid is required" },
          },
          {
            name: "DeviceType",
            label: "Device Type",
            type: "text",
            validation: { required: "Device type is required" },
          },

          {
            name: "HeadQuaterName",
            label: "Wua",
            isDropdown: true,
            dropdownData: wuaData,
            dropdownLabel: "headQuaterName",
            idFieldName: "Wua_Id",
          },

          {
            name: "Scheme_Village",
            label: "Scheme Village",
            isDropdown: true,
            dropdownData: schemeVillageData,
            dropdownLabel: "scheme_Village",
            idFieldName: "SchemeVillageId",
          },
          {
            name: "Distributary_Zone",
            label: "Distributary Zone",
            isDropdown: true,
            dropdownData: distributaryData,
            dropdownLabel: "distributary_Zone",
            idFieldName: "DistributaryZoneId",
          },
        ]}
      />
    </>
  );
};

export default AddChack;
